import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { createGlobalStyle } from "styled-components";

import jllTheme from "@jll/jll.capability.designsystem.restyles.mui";
import colors from "./colors";
import { useSelector } from "react-redux";

const TmeGlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    font-family: Source Sans Pro;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 12px;
  }
  *, button {
    font-family: Source Sans Pro;
  }
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
      monospace;
  }
  .modebar {
    display: none !important;
  }

  .MuiDataGrid-columnHeader {
    height: 40px!important;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #888;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;


const tmeTheme = createTheme({
  palette: {
    primary: {
      light: "#001F2B",
      main: "#3D768A",
      dark: "#00151D",
      contrastText: "#FFFFFF",
    },
    secondary: {
      light: "#757ce8",
      main: "#3f50b5",
      dark: "#002884",
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: [
      "Source Sans Pro"
    ].join(","),
    fontSize: 12,
    h2: {
      fontSize: "1.5em",
      fontWeight: "bold",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: colors.coreColors.jllRed.primary,
          color: colors.coreColors.white.core,
        },
      },
    },
  },
});

export const ThemeProviderTme = ({ children }) => {
  const [theme, setTheme] = useState(tmeTheme);

  useEffect(() => {
    setTheme(tmeTheme);
  }, []);

  return (
    <>
      <TmeGlobalStyles />
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </>
  );
};
